import { render, staticRenderFns } from "./PrivacyModal_Text.vue?vue&type=template&id=0401b462&"
import script from "./PrivacyModal_Text.vue?vue&type=script&lang=js&"
export * from "./PrivacyModal_Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports